import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import CrmPipelineCard from './CrmPipelineCard';

const CrmPipelineColumn = ({ etapa, items, onSelect, selectedId }) => {
  const { isOver, setNodeRef } = useDroppable({ id: etapa.value });

  return (
    <div style={{
      width: '230px',
      flexShrink: 0,
      display: 'flex',
      flexDirection: 'column',
      borderRadius: '12px',
      overflow: 'hidden',
      border: '1px solid #e5e7eb',
      background: '#f9fafb',
      maxHeight: '100%',
    }}>
      {/* Header de columna */}
      <div style={{
        padding: '0.7rem 0.875rem',
        background: etapa.color + '18',
        borderBottom: `2px solid ${etapa.color}35`,
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        flexShrink: 0,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <span style={{
            width: '9px', height: '9px', borderRadius: '50%',
            background: etapa.color, flexShrink: 0,
          }} />
          <span style={{ fontWeight: '700', fontSize: '0.82rem', color: '#374151' }}>
            {etapa.label}
          </span>
        </div>
        <span style={{
          background: etapa.color,
          color: 'white',
          borderRadius: '10px',
          padding: '0.1rem 0.45rem',
          fontSize: '0.7rem',
          fontWeight: '700',
          minWidth: '18px',
          textAlign: 'center',
        }}>
          {items.length}
        </span>
      </div>

      {/* Zona droppable */}
      <div
        ref={setNodeRef}
        style={{
          flex: 1,
          overflowY: 'auto',
          padding: '0.6rem',
          minHeight: '100px',
          background: isOver ? etapa.color + '12' : 'transparent',
          transition: 'background 0.15s',
        }}
      >
        {items.map(p => (
          <CrmPipelineCard
            key={p.id}
            prospecto={p}
            onSelect={onSelect}
            isSelected={p.id === selectedId}
          />
        ))}

        {items.length === 0 && (
          <div style={{
            height: '64px',
            border: `2px dashed ${etapa.color}35`,
            borderRadius: '8px',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#d1d5db', fontSize: '0.75rem',
          }}>
            Vacío
          </div>
        )}
      </div>
    </div>
  );
};

export default CrmPipelineColumn;
